import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNominationCountries: (
  fetchContext: FetchContext,
  nominationId: number,
  countryIds: number[],
  accessToken?: string,
) => Promise<void> = async (fetchContext, nominationId, countryIds, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/nominations/${nominationId}/countries`,
  {
    method: 'PUT',
    body: JSON.stringify(countryIds),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update nomination countries'));
